import { ApiResponse, fetchApi } from './common';

// 获取二维码请求接口
export interface GetQRCodeRequest {
  userType: string; // 用户类型：doctor 或 patient
}

// 获取二维码响应接口
export interface GetQRCodeResponse {
  token: string;         // 生成的临时token
  qr_code_base64: string;  // 二维码的base64编码
}

// 检查token状态请求接口
export interface CheckTokenStateRequest {
  token: string; // 临时token
}

// 检查token状态响应接口
export interface CheckTokenStateResponse {
  is_valid: boolean;  // Token是否有效
  state: number;     // Token当前状态
  user_id?: string;   // 确认登录后的用户ID
  user_type?: string; // 确认登录后的用户类型
}

// 微信扫码登录API请求函数
export const wechatScanLoginApi = {
  // 获取微信扫码登录二维码
  getQRCode: async (userType: string): Promise<ApiResponse<GetQRCodeResponse>> => fetchApi<GetQRCodeResponse>(`/api/wechat-scan-login/get-qr-code?userType=${userType}`, 'GET'),

  // 检查token状态
  checkTokenState: async (data: CheckTokenStateRequest): Promise<ApiResponse<CheckTokenStateResponse>> => fetchApi<CheckTokenStateResponse>('/api/wechat-scan-login/check-token-state', 'POST', data),
};
